import {
    useQuery
} from 'react-query';

export default function useGetPostTags() {
    const landscapeId = RivalIQ.state.landscape.get('id');
    return useQuery(['postTags'], async () => {
        const configuration = await $.getJSON(`/api/landscape/${landscapeId}/postTags`);
        return configuration;
    }, {
        staleTime: Infinity
    });
}
